// Shared helpers for the Ordering module — kept tiny and self-contained.
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const ORDER_PIN_KEY = 'scorz_order_admin_pin';

export const getOrderPin = () => localStorage.getItem(ORDER_PIN_KEY) || '';
export const setOrderPin = (pin) => {
  if (pin) localStorage.setItem(ORDER_PIN_KEY, pin);
  else localStorage.removeItem(ORDER_PIN_KEY);
};

export const adminAxios = () => axios.create({
  baseURL: API,
  headers: { 'X-Admin-Pin': getOrderPin() },
});

export const formatPence = (p) => `£${(Number(p || 0) / 100).toFixed(2)}`;
